import initStore from './initStore';
import actions from './actions';
import thunks from './thunks';

import { INotificationsModel } from './types';

const notifications: INotificationsModel = {
  ...initStore,
  ...actions,
  ...thunks,
};

export default notifications;
